/**
 * adSettings — pure normalisation of GET /api/settings into the ad switches
 * (used by hooks/useAdSettings; kept DOM- and network-free for jest).
 *
 * In-article (`enabled`) and Multiplex (`multiplexEnabled`) each need
 * ads_enabled === true AND their own valid slot ID (1-20 digits).
 */
export const ADSENSE_CLIENT = 'ca-pub-9245396063950311';

const validSlot = (v) => (/^\d{1,20}$/.test(String(v || '')) ? String(v) : '');

export function normalise(d = {}) {
  const on = d.ads_enabled === true;
  const slot = validSlot(d.adsense_inarticle_slot);
  const multiplexSlot = validSlot(d.adsense_multiplex_slot);
  const client = /^ca-pub-\d{10,20}$/.test(String(d.adsense_publisher_id || '')) ? d.adsense_publisher_id : ADSENSE_CLIENT;
  return { enabled: on && slot !== '', client, slot, multiplexEnabled: on && multiplexSlot !== '', multiplexSlot };
}
